import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function AI_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. Introduction to Python</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Python basic, Python concepts & terms, Python fundamentals, Python data structure & modules.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. Introduction to Data Analysis</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Pandas & visualization
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. Statistics & probability</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to probability, Distribution central limits theorem & hypothesis testing.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. AI Introduction</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Artificial intelligence, Applications of Artificial intelligence, Hands on work with Python.     
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Deep learning</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Neuron deep learning (basics & scope), Evolution of deep learning, Applications of Deep learning, Machine learning Vs. Deep learning, Techniques & types of deep learning, Introduction to ANN.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. Artificial Neural Networks</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Neuron Diagram, Neuron Models & NETWORK FUCTIONS, Functions of Neurons activation, Functions of Gradient descent &Stochastic, Ramp function & sigmoid function & Gaussian function.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. Network Installation</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Perceptron & multlilayer network, Backpropagation, Deep neural network installing libraries, Creating ANN, Python training the model.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. Convolutional Neural Networks</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to open Cv (Image processing), Learning basic image manipulations, Introduction to CNN, CNN Institution, Convolution Operation pooling, Flattering building a CNN using python Training the model.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-5'>9. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
